import cn from 'classnames';

import BaconLeekChicken from 'images/bacon-leek-grilled-chicken.png';
import BajaCitrusSalmon from 'images/baja-citrus-salmon.png';
import NavyWaveBorder from 'images/tempoNavyWaveBorder.svg';

const SharapovaImageSection = () => {
  return (
    <>
      <div
        style={{ backgroundImage: `url(${NavyWaveBorder})` }}
        className="-mt-px h-12 bg-repeat-x p-0 bp1:mb-8"
      />
      <div>
        <img
          className={cn(
            'absolute bp1:inset-1/2 bp1:top-28 bp1:translate-x-64',
            'bp3:top-22 -right-10 -top-10 w-36 bp1:-right-6 bp1:w-56'
          )}
          src={BaconLeekChicken}
          alt="Bacon Leek Grilled Chicken"
        />
        <img
          className={cn(
            'absolute bp1:inset-1/2 bp1:top-28 bp1:w-52 bp1:-translate-x-[32rem]',
            'bp3:top-22 -left-10 -top-9 w-36 rotate-[-12deg] bp1:rotate-0'
          )}
          src={BajaCitrusSalmon}
          alt="Baja Citrus Salmon"
        />
      </div>
    </>
  );
};

export default SharapovaImageSection;
